// extracted by mini-css-extract-plugin
export default {"instructions":"Instructions_instructions__zGd0N","hiddenRow":"Instructions_hiddenRow__zewjb","singularKey":"Instructions_singularKey__PZEu8"};